import React from "react";
import { Navigate } from "react-router-dom";
import { useLoginContextSU } from "../context/loginContextSU";
import { role } from "../utils/globalVariables";
import { safetyDecodeJWT } from "../utils/globalFunctions";

const SuperUserRoute = ({ stateComponent }) => {

    const { loginContextSU } = useLoginContextSU();

    try {
        if (safetyDecodeJWT(loginContextSU, 'syswebapp', 'syswebappsl') === role.super_user.subLevel.super_user.slugSubLevel) {
            return stateComponent;
        }
        else {
            return <Navigate to='/superuser' replace={true} />;
        }
    } catch (error) {
        return <Navigate to='/superuser' replace={true} />;
    }
}

export default SuperUserRoute;